import React from 'react';
import * as routes from 'constants/routes';
import { RxDashboard } from 'react-icons/rx';
import { TbMessageChatbot } from 'react-icons/tb';
import { GiChickenOven } from 'react-icons/gi';
import { PiListChecks } from 'react-icons/pi';
import { MdOutlineDiscount } from 'react-icons/md';
import { RiAdvertisementLine } from 'react-icons/ri';
import { PiUsersThree } from 'react-icons/pi';
import { MdOutlineReviews } from 'react-icons/md';
import { RiMailVolumeLine } from 'react-icons/ri';
import { GrUserSettings } from 'react-icons/gr';
import { PiUsersFour } from 'react-icons/pi';
import { BiMessageRoundedEdit } from 'react-icons/bi';
import { IoIosSettings } from 'react-icons/io';
import { AiFillDatabase } from 'react-icons/ai';
import { RiCouponLine } from 'react-icons/ri';
import { IoImagesOutline } from 'react-icons/io5';

interface SubMenuItem {
  title: string;
  to?: string;
  icon?: React.ComponentType<any>;
  policy?: string;
}

interface MenuItem {
  name: string;
  to?: string;
  icon: React.ComponentType<any>;
  policy?: string;
  subMenu?: SubMenuItem[];
}

const sideMenuItems: MenuItem[] = [
  {
    name: 'Dashboard',
    to: '/',
    icon: RxDashboard,
  },
  {
    name: 'Orders',
    to: routes.ORDER,
    icon: TbMessageChatbot,
    policy: 'order.index',
  },
  {
    name: 'Products',
    to: routes.PRODUCTS,
    icon: GiChickenOven,
    policy: 'product.index',
  },
  {
    name: 'Categories',
    to: routes.CATEGORIES,
    icon: PiListChecks,
    policy: 'categories.index',
  },

  {
    name: 'Reviews',
    to: routes.REVIEWS,
    icon: MdOutlineReviews,
    policy: 'reviews.index',
  },
  {
    name: 'Subscriptions',
    to: routes.SUBSCRIPTIONS,
    icon: RiMailVolumeLine,
    policy: 'subscriptions.index',
  },
  {
    name: 'Customers',
    to: routes.CUSTOMERS,
    icon: PiUsersFour,
    policy: 'customers.index',
  },
  {
    name: 'Settings',
    icon: IoIosSettings,
    policy: 'role.index',
    subMenu: [
      {
        title: 'Users',
        to: routes.USERS,
        icon: PiUsersThree,
        policy: 'users.index',
      },
      {
        title: 'Roles',
        to: routes.ROLES,
        icon: GrUserSettings,
        policy: 'role.index',
      },
      {
        title: 'Default Settings',
        to: routes.DEFAULTSETTINGS,
        icon: IoIosSettings,
        policy: 'default.index',
      },
    ],
  },
  {
    name: 'Master Data',
    icon: AiFillDatabase,
    policy: 'role.index',
    subMenu: [
      {
        title: 'Offers',
        to: routes.OFFERS,
        icon: MdOutlineDiscount,
        policy: 'offers.index',
      },
      {
        title: 'Landing Images',
        to: routes.LANDING_IMAGES,
        icon: IoImagesOutline,
        policy: 'advertisements.index',
      },
      {
        title: 'Advertisements',
        to: routes.ADVERTISEMENTS,
        icon: RiAdvertisementLine,
        policy: 'advertisements.index',
      },
      {
        title: 'Coupons',
        to: routes.COUPONS,
        icon: RiCouponLine,
        policy: 'coupons.index',
      },
    ],
  },
  {
    name: 'Inquiries',
    to: routes.INQUIRIES,
    icon: BiMessageRoundedEdit,
    policy: 'inquiries.index',
  },
];
export default sideMenuItems;
